import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box, Text,
} from '@chakra-ui/react';
import ProgressItem from '../../Core/ProgressItem';
import { useGetFormStatsQuery } from '../../Services/apiSlice';

const PlanDetails = () => {
  const { data: stats, isFetching, error } = useGetFormStatsQuery();
  return (
    <Box color="gray.400" my="4">
      <Accordion allowToggle>
        <AccordionItem border="none">
          <AccordionButton px="2">
            <Box as="span" flex="1" textAlign="left">
              <Text fontSize="xs">
                You&apos;re on a
                <Text ml="1" as="b">
                  {(isFetching || error) ? '' : stats.plan}
                  {' '}
                  Plan
                </Text>
              </Text>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pt="0" bg="blackAlpha.20">
            {!isFetching && !error && (
              <Box px={1}>
                <ProgressItem text="Forms" value={stats.currentFormsCount || 0} total={stats.maxForms || 5} />
                <ProgressItem text="Submissions/Mo" value={stats.submissions || 0} total={stats.submissionsPerMonth || 100} />
              </Box>
            )}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
};

export default PlanDetails;
